// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__25W2M","title":"Info_title__28K0x","selects":"Info_selects__1rUEY","requiredAsterisk":"Info_requiredAsterisk__3rUmS"};